<script>
export default {
  name: "PriceComponent",
  props: {
    objectPrice: {
      type: Number,
      required: true
    },
    objectPriceSale: {
      type: Number,
      required: true
    },
    reportType: {
      type: Number,
      required: true
    },
    paperReportPrice: {
      type: Number,
      required: true
    }
  }
}
</script>

<template>
  <div class="td price">
    <template v-if="!objectPriceSale">
      <p>{{ objectPrice }} руб.</p>
    </template>
    <template v-else>
      <p class="price_sale">{{ objectPrice }} руб.</p>
      <p>{{ objectPriceSale }} руб.</p>
    </template>
    <p v-if="reportType === 2">+{{ paperReportPrice }} руб.</p>
  </div>
</template>

<style scoped>

.price p {
  margin-bottom: 0;
}

.price_sale {
  color: red;
  text-decoration: line-through;
}

</style>
